import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { userIdAtom, userResponseAtom } from './user.atoms'
import { useMemo } from 'react'
import { doAdminMutation, reinstateUsers } from '../providers/mutations'

export function useUserResource(userId: string | number) {
  const id = Number(userId)
  useSetAtom(userIdAtom)(id)
  const [userData, reFetchUser] = useAtom(userResponseAtom)

  return useMemo(() => {
    return {
      userData,
      reFetchUser,
      addUserRole: async (user_role: string) => {
        await doAdminMutation(
          {
            key: 'addUserRole',
            fields: ['id'],
          },
          { user_id: id, user_role },
        )
        reFetchUser()
      },
      removeUserRole: async (user_role: string) => {
        await doAdminMutation(
          {
            key: 'removeUserRole',
            fields: ['id'],
          },
          { user_id: id, user_role },
        )
        reFetchUser()
      },
      reinstate: async () => {
        await reinstateUsers({ user_ids: [id] })
        reFetchUser()
      },
    }
  }, [id, userData, reFetchUser])
}
